"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFilter = void 0;
function isEQ(op) {
    return op.eq !== undefined;
}
function isNEQ(op) {
    return op.neq !== undefined;
}
function isOneOf(op) {
    return Array.isArray(op.oneOf);
}
class EventFilter {
    constructor(filters) {
        this.filters = filters;
    }
    static mk(_tkey, filters) {
        return new EventFilter(filters);
        // return {
        //   filters
        // }
    }
    static Test(filter, args) {
        if (!filter) {
            return true;
        }
        const { filters } = filter;
        // filters
        for (const [key, operands] of Object.entries(filters)) {
            const segments = key.split(".");
            let context = args;
            for (let i = 0; i < segments.length; i++) {
                context = context[segments[i]];
                if (context === undefined) {
                    return false;
                }
            }
            if (isOneOf(operands)) {
                if (!operands.oneOf.some((value) => value === context)) {
                    return false;
                }
            }
            if (isEQ(operands)) {
                if (context !== operands.eq) {
                    return false;
                }
            }
            if (isNEQ(operands)) {
                if (context === operands.neq) {
                    return false;
                }
            }
        }
        return true;
    }
}
exports.EventFilter = EventFilter;
